import React from "react";

import Newsb from "../../../assets/image/news-1.jpg"
import Newsa from "../../../assets/image/news-2.jpg"
import Newse from "../../../assets/image/news-3.jpg"
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";


// image: "/images/news-1.jpg",

const newsData = [
    {
        id: 1,
        title: "The Human Rights and Democracy Programme",
        image: Newsb,
        date: "13",
        month: "Aug",
        author: "admin",
        category: "Europe Permit",
    },
    {
        id: 2,
        title: "Project Concepts & Related Queries",
        image: Newsa,
        date: "13",
        month: "Aug",
        author: "admin",
        category: "Immigration",
    },
    {
        id: 3,
        title: "Priority File Application Updates",
        image: Newse,
        date: "13",
        month: "Aug",
        author: "admin",
        category: "Study Visa",
    },
];

const NewsUpdates = () => {
    return (
        <section className="py-10 md:py-20">
            <div className="max-w-7xl mx-auto px-4">

                {/* Top Heading Row */}
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 mb-14">
                    <div>
                        <p className="uppercase tracking-widest font-[600] text-[#777777]">
                            How We Help Clients
                        </p>
                        <h2 className="text-3xl md:text-5xl font-bold text-black my-6">
                            World Immigration
                            News & Updates
                        </h2>
                        <div className="flex gap-2 items-center">
                            <div className="w-12 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div></div>
                    </div>

                    <p className="text-xl md:text-[19px] text-[#555555] leading-relaxed">
                        Stay informed with the latest immigration developments.


                    </p>
                </div>

                {/* News Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {newsData.map((item) => (
                        <Link to="https://www.cicnews.com/"
                            key={item.id}
                            className="bg-[#eff2f5] shadow-sm border overflow-hidden group"
                        >
                            {/* Image */}
                            <div className="relative">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-full h-66 object-cover transition-transform duration-500 group-hover:scale-105"
                                />

                                {/* Date Badge */}
                                <div className="absolute bottom-0 right-6 bg-red-500 text-white text-center px-4 py-2">
                                    <p className="text-[26px] font-bold leading-none">
                                        {item.date}
                                    </p>
                                    <span className="text-xs uppercase">{item.month}</span>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="p-6">
                                <h3 className="font-semibold text-[#222222] text-[26px] mb-3 leading-snug">
                                    {item.title}
                                </h3>



                                <p className="text-sm text-gray-500 mb-4">
                                    By {item.author} | {item.category}
                                </p>

                                <div className="w-10 h-1 bg-[#ec4e4f] mb-4"></div>

                                {/* <Link
                                    to={`/news/${item.id}`}
                                    className="inline-flex items-center cabin text-[18px] font-semibold text-[#555555] hover:text-red-500 transition"
                                >
                                    Read More →
                                </Link> */}
                            </div>
                        </Link>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default NewsUpdates;
